import React, { useState, useEffect } from 'react';
import '../../CSS/cardStudio.css';
import { restrictNegativeInput, handlePositiveNumberChange } from '../../utils/numberInputHelpers';
import { TextField, Typography, Slider, Box, Grid, FormControlLabel, RadioGroup, Radio, FormLabel, Switch } from '@mui/material';
import { useStudio } from '../../Context/StudioContext';
import { X } from 'lucide-react'
import SlotTimeSchedule from './SlotTimeSchedule';



const Page5Settings = () => {
    const { formData, setFormData } = useStudio();

    useEffect(() => {
        if (formData.packageType === 'Basic') {
            if (formData.showRSVP) {
                setFormData(prev => ({
                    ...prev,
                    showRSVP: false,

                }));
            }
        }
    }, [formData.packageType, formData.showRSVP, setFormData]);

    const handlePositiveNumberChange = (field, value) => {
        // Allow empty string or positive integer
        if (value === '' || (/^\d+$/.test(value) && Number(value) >= 0)) {
            setFormData(prev => ({ ...prev, [field]: value }));
        }
    };

    const showRSVP = formData.showRSVP
    const showSlotTime = formData.showSlotTime
    const showOnlyWishes = formData.showOnlyWishes

    const handleChangeRSVPType = (value) => {
        setFormData((prev) => {
            let updatedData = {
                ...prev,
                showRSVP: value === 'normalRSVP',
                showSlotTime: value === 'slotRSVP',
                showOnlyWishes: value === 'onlyWishes',
            };

            // If switching away from slotRSVP, reset slotTimes to default (1 slot)
            if (value !== 'slotRSVP') {
                updatedData.slotTimes = [
                    {
                        slotTimeStart: '11:00',
                        slotTimeEnd: '12:00',
                        label: 'Keluarga',
                        guestPerPax: '',
                        totalGuest: '',
                    },
                ];
            }

            return updatedData;
        });
    };



    return (
        <Box sx={{ display: 'grid' }}>

            <Typography variant="h6">RSVP & Ucapan</Typography>
            {formData.packageType === 'Basic' && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                    <X size={16} color="#701d1dff" />
                    <Typography variant="body2" color="#701d1dff">Fungsi ini hanya tersedia untuk pakej Standard dan Premium</Typography>
                </Box>
            )}

            <FormControlLabel
                sx={{ mt: 1 }}
                label="Ucapan Sahaja"
                disabled={formData.packageType === 'Basic'}
                control={
                    <Radio
                        checked={showOnlyWishes}
                        onChange={() => handleChangeRSVPType('onlyWishes')}
                        sx={{
                            color: '#68D2D2',
                            '&.Mui-checked': {
                                color: '#68D2D2',
                            },
                        }}
                    />
                }
            />

            {/* RSVP Biasa */}
            <FormControlLabel
                sx={{ mt: 1 }}
                label="RSVP Biasa"
                disabled={formData.packageType === 'Basic'}
                control={
                    <Radio
                        checked={showRSVP && !showSlotTime}
                        onChange={() => handleChangeRSVPType('normalRSVP')}
                        sx={{
                            color: '#68D2D2',
                            '&.Mui-checked': {
                                color: '#68D2D2',
                            },
                        }}
                    />
                }
            />



            <TextField
                label="Had Kehadiran per Tetamu"
                fullWidth
                disabled={!showRSVP || showSlotTime}
                type="number"
                value={formData.guestPerPax}
                onChange={(e) => handlePositiveNumberChange('guestPerPax', e.target.value)}
                margin="normal"
                InputLabelProps={{ shrink: true }}
            />

            <TextField
                label="Jumlah Keseluruhan Tetamu"
                fullWidth
                disabled={!showRSVP || showSlotTime}
                type="number"
                value={formData.totalGuest}
                onChange={(e) => handlePositiveNumberChange('totalGuest', e.target.value)}
                margin="normal"
                InputLabelProps={{ shrink: true }}

            />

            <FormControlLabel
                sx={{ mt: 1 }}
                label="RSVP Slot Waktu"
                disabled={formData.packageType === 'Basic'}
                control={
                    <Radio
                        checked={showSlotTime}
                        onChange={() => handleChangeRSVPType('slotRSVP')}
                        sx={{
                            color: '#68D2D2',
                            '&.Mui-checked': {
                                color: '#68D2D2',
                            },
                        }}
                    />
                }
            />

            <>
                <SlotTimeSchedule />
            </>

        </Box>


    );
};

export default Page5Settings;
